<template>
  <c-flex mr="-30px" ml="-30px" flexDirection="column">
    <c-box
      :height="{ base: '280px', sm: '330px', md: '450px' }"
      background="#4b4b4b"
      backgroundImage="url(/img/support/returns/header.jpg)"
      backgroundPosition="50% 85%"
      backgroundSize="cover"
      borderRadius="base"
      position="relative"
      overflow="hidden"
      mr="xl"
      v-chakra="{
        '@media (min-width: 2048px)': {
          mr: '0',
        },
      }"
      :mt="{ base: '3xl', sm: '3rem', md: '4xl' }"
      :ml="{ base: 'xl', xl: '2xl' }"
      maxWidth="100%"
    >
    </c-box>

    <c-flex mt="4xl" alignItems="center" justifyContent="center">
      <c-box :maxWidth="{ base: '80%', lg: '50%' }">
        <c-flex>
          <c-flex flexDirection="column" alignItems="left">
            <c-box>
              <c-heading color="brand.purple" lineHeight="1.5em" fontSize="1.5rem" as="h3">
                {{ $t("productReturn.common.title") }}</c-heading
              >
              <c-text
                mt="sm"
                md="sm"
                v-html="$t('productReturn.contactCustomerService.text')"
                v-chakra="{
                  '& > a': {
                    textDecoration: 'underline',
                  },
                }"
              />
            </c-box>
          </c-flex>
        </c-flex>
      </c-box>
    </c-flex>
  </c-flex>
</template>

<script lang="ts">
import { CBox, CFlex, CHeading, CLink, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReturnsContact",
  components: {
    CHeading,
    CLink,
    CText,
    CBox,
    CFlex,
  },
});
</script>
